const userData = JSON.parse(localStorage.getItem('authentication'))
const admins = {
  30: '30',
  14: '14',
  0: '0',
  114: '114',
}

const location = window.location.pathname

if (!userData && location !== '/login') {
  window.location.href = '/login'
}

export const user = {
  ...userData,
  isAdmin: admins[userData?.codigo_usuario] !== undefined,
}
